export default __webpack_public_path__ + "static/media/section1.e58d2e7d.svg";